import { inject, Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { GetFhirPatientSearchR4Response } from '../../model/GetFhirPatientSearchR4Response';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import {compactDecrypt} from 'jose';
import { decode as base64Decode } from 'base64-arraybuffer';
import { MCAppGatewayService } from '../mcappgateway/mcappgateway.service';
import { AuthenticateExtensibilityUserRequest } from '../../model/AuthenticateExtensibilityUserRequest';
import { AuthenticateExtensibilityUserResponse } from '../../model/AuthenticateExtensibilityUserResponse';
import axios, { AxiosRequestConfig } from 'axios';
import { provideProtractorTestingSupport } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  mcAppGatewayService: any = inject(MCAppGatewayService);
  authToken!: string | null;
  isAuthRequired: boolean = true;

  public context = "";

  public eptID: string | null = null;
  public wprID: string | null = null;
  public datetimeStr: string | null = null;
  

  constructor(private route: ActivatedRoute, private http: HttpClient) { }

  async isAuthenticated(): Promise<boolean> {
    // Check if the user is already authenticated
    sessionStorage.clear(); // Clear session storage for testing purposes

    // If the user is not authenticated
    // Extract JWT string from the URL context parameter
    const url = window.location.href;
    const urlObj = new URL(url);
    const contextStr: string = urlObj.searchParams.get('context') ?? "";
    const fdiStr: string = urlObj.searchParams.get('fdi') ?? "";

    if (url.includes('get-care-now')) {
      this.isAuthRequired = false;
    } else if (url.includes('pre-login')) {
      this.isAuthRequired = false;
    } else if (url.includes('find-care')) {
      this.isAuthRequired = false;
    }
    else {
      this.isAuthRequired = true;
    }
    

    if (!contextStr || contextStr.length === 0) {

      console.warn("contextStr is empty; is auth required? " + this.isAuthRequired);
      return this.isAuthRequired == false; // If auth is not required, allow access
    }

    if (!fdiStr || fdiStr.length === 0) {
      console.warn("fdiStr is empty; is auth required? " + this.isAuthRequired);
      return this.isAuthRequired == false; // If auth is not required, allow access
    }

    sessionStorage.setItem("context", contextStr);

    const authRequest = {
      context: contextStr,
      fdi: fdiStr,
      isMobileLaunch: window.location.href.includes('mobile'),
    } as AuthenticateExtensibilityUserRequest;

    // Call MCAppGateway to authenticate the user
    // The MCAppGateway service will handle the auth request and return an observable containing
    // the decrypted parameters (eptID, wprID) and the token used to call Interconnect APIs
    try {
      const authResponse = await new Promise<boolean>((resolve, reject) => {
        this.mcAppGatewayService.PostAuthenticateExtensibilityUser(authRequest).subscribe({
          next: async (response: AuthenticateExtensibilityUserResponse) => {
            // Check if the response contains the expected data
            if (!response || !response.eptID || !response.wprID || !response.token || !response.fhirID) {
              resolve(this.isAuthRequired == false); // If auth is not required, allow access
              return;
            }

            // Save all parameters to sessionStorage
            sessionStorage.setItem("eptID", response.eptID);
            sessionStorage.setItem("wprID", response.wprID);
            sessionStorage.setItem("fhirID", response.fhirID);
            sessionStorage.setItem("timestamp", response.timestamp.toString());
            sessionStorage.setItem("token", response.token);
            sessionStorage.setItem("age", response.age?.toString() || "");
            sessionStorage.setItem("gender", response.gender || "");
            sessionStorage.setItem("patientFirstName", response.FhirPatientInfo?.Entry[0]?.Resource?.Name[0].Given.join(" ") ?? "");
            sessionStorage.setItem("patientLastName", response.FhirPatientInfo?.Entry[0]?.Resource?.Name[0].Family ?? "");
            sessionStorage.setItem("patientEmail", response.FhirPatientInfo?.Entry[0]?.Resource?.Telecom?.find((t: any) => t.System === 'email')?.Value ?? "");
            sessionStorage.setItem("hasPCP",response.FhirPatientInfo?.Entry[0].Resource?.GeneralPractitioner && response.FhirPatientInfo?.Entry[0].Resource?.GeneralPractitioner.length > 0 ? 'true' : 'false');
            if (response.isPlus !== null && response.isPlus !== undefined) {
              sessionStorage.setItem("isPlus", response.isPlus.toString());
            }

            resolve(true);
          },
          error: (error: any) => {
            console.error("Error in MCAppGateway response:", error);
            resolve(this.isAuthRequired == false); // If auth is not required, allow access
          }
        });
      });

      return authResponse;

    } catch (error) {
      console.error("Error making POST call to MCAppGateway:", error);
      return this.isAuthRequired == false;  // If auth is not required, allow access
    }
  }
  
}



